import { ColorInterface, ColorInterfaceExternalbtn, Externalbtn } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ToolsService } from '../services/tools.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-sbeditor-tool-externalbtn',
  templateUrl: './externalbtn.component.html',
  styleUrls: ['./externalbtn.component.scss'],
})
export class ExternalbtnComponent implements OnInit, OnDestroy {
  @Output() exportTool = new EventEmitter<Externalbtn>();
  public tool: Externalbtn;
  public subscriptions: Array<Subscription>;
  public colors: ColorInterfaceExternalbtn;
  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.externalbtn) {
        this.tool = Object.assign({}, res.externalbtn);
        this.colors = Object.assign({}, res.color.manual.externalbtn);
      } else {
        console.error('External btn tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  public getTool(): { tool: Externalbtn; colors: ColorInterfaceExternalbtn } {
    return { tool: this.tool, colors: this.colors };
  }
}
